export default __webpack_public_path__ + "static/media/Outlinebell.57f5d44c.svg";